'use strict';

var angular = require('angular');
var _ = require('lodash');
require('./fonts');
require('./vendor');
var lazyBootstrap = require('./bootstrap');
var context = require.context('.', true, /Module.js$/);
var paths = context.keys();
var modules = _.transform(paths, function (result, value) {
  var module = context(value).name;
  result.push(module);
});
angular.module('AVRO', modules);
var Q = require('q');
lazyBootstrap('AVRO', ['AVRO.Common.Bootstrap']).resolve(['BootstrapService', function (bootstrapService) {
  return bootstrapService.load().then(function () {
    var splashElement = angular.element('.intro-splash');
    function removeSplashElement() {
      splashElement.off().remove();
    }
    var deferred = Q.defer();
    splashElement.on('transitionend', function () {
      deferred.resolve();
    }).addClass('inactive');
    deferred.promise.timeout(500).then(removeSplashElement, removeSplashElement);
  });
}]).error(function (errResponse) {
  if (errResponse.status && [401, 412].indexOf(errResponse.status) === -1) {
    return false;
  }
  var carrierCode = sessionStorage.getItem('carrierCode');
  angular.element.ajax({
    url: '/api/authenticateduser'
  }).done(function (user) {
    if (user.organization !== 'SG') {
      sessionStorage.setItem('carrierCode', user.organization);
      var splashElement = angular.element('.intro-splash');
      var message = require('./user-landing/user-landing-panel/templates/user-landing-splash-message.html');
      splashElement.find('.intro-splash-spinner').remove();
      splashElement.append(message);
      return;
    }
    if (user.organization === 'SG') {
      if (carrierCode) {
        var splashElement1 = angular.element('.intro-splash');
        var message1 = require('./user-landing/user-landing-panel/templates/user-landing-splash-message.html');
        splashElement1.find('.intro-splash-spinner').remove();
        splashElement1.append(message1);
        return;
      } else {
        var splashElement2 = angular.element('.intro-splash');
        var message2 = require('./user-landing/user-select-carrier-panel/templates/select-carrier-message.html');
        splashElement2.find('.intro-splash-spinner').remove();
        splashElement2.append(message2);
        angular.element('.ok-button').prop('disabled', true);
        angular.element.ajax({
          url: '/api/configuration/carriers',
          success: function success(carriers) {
            var option = '';
            for (var i = 0; i < carriers.results.length; i++) {
              option += '<option value"' + carriers.results[i] + '">' + carriers.results[i] + '</option>';
            }
            angular.element('#carrier-combobox').append(option);
          }
        });
        angular.element('#carrier-combobox').on('change', function () {
          if (angular.element('#carrier-combobox').val() !== null) {
            angular.element('.ok-button').prop('disabled', false);
          }
        });
        angular.element('.ok-button').click(function () {
          sessionStorage.setItem('carrierCode', angular.element('#carrier-combobox').val());
          window.location.reload();
        });
        return;
      }
    }
  }).fail(function () {
    var splashElement1 = angular.element('.intro-splash');
    var message1 = require('./user-landing/user-landing-panel/templates/user-landing-splash-message.html');
    splashElement1.find('.intro-splash-spinner').remove();
    splashElement1.append(message1);
    return;
  });
}).bootstrap();